<script lang='ts'>
import { reactive, defineComponent } from '@vue/composition-api';
import { commandDispatcher } from '@/_core/cqrs';
import { SendUserFeedback } from '@/api/common';
import { snackbar } from '@/_core/app-components/use';
import { useIsOpen } from '@/_core/utils/use/useIsOpen';

interface IProps {
    isOpen: boolean;
}

const UserFeedback = defineComponent({
    name: 'UserFeedback',
    props: { isOpen: Boolean },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({
            message: '',
            dialog: useIsOpen(),
        });

        const onClose = () => {
            state.dialog.close();
        };

        const onSave = () => {
            const message = state.message.trim().substring(0, 1000);
            commandDispatcher.dispatchCommand(new SendUserFeedback('Other', null, message, true));
            snackbar.showSuccess('Feedback successfully submitted');

            onClose();
        };

        return {
            state,

            onClose,
            onSave,
        };
    },
});

export default UserFeedback;
</script>

<template>
  <v-list-item class="mb-0" @click="state.dialog.open">
    <AppDialog
      title="Help us improve"
      :isOpen="state.dialog.isOpen"
      :shouldCloseOnClickOutside="true"
      :width="800"
      @close="state.dialog.close"
    >
      <v-card-text class="pb-2">
        <div class="secondaryText--text" style="font-size: 16px; line-height: 24px;">
          <div class="mt-3">
            We'd love to hear what you think! Drop your thoughts and ideas here - they really help us make things better for you. 😊
          </div>  
          <v-textarea
            v-model="state.message"
            class="mt-2"
            autofocus
            :counter="1000"

            solo-inverted
            flat
            auto-grow
            rows="5"
          />

          <div class="d-flex">
            <v-spacer />
            <v-btn
              class="mt-5"
              color="primary"
              depressed
              @click="onSave"
            >
              Submit
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </AppDialog>

    <v-list-item-avatar
      style="border-radius: 50% !important; cursor: default;  width: 40px !important; min-width: 40px !important; height: 40px !important; font-size: 16px; font-weight: 700;"
      class=" mr-4"
    >
      <v-icon color="blueGrey90Light" size="24">
        $fatCommentPen
      </v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>Feedback</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<style lang='scss' scoped></style>